/* globals jQuery, wpAjaxURL */

import _ from 'underscore';
import cookies from 'js-cookie';

const getReferer = {
  init() {
    const ajaxurl = wpAjaxURL;
    let currentReferrer = document.referrer;

    // Use Provided Callrail referrer if document ref is empty
    if (
      _.isEmpty(currentReferrer) ||
      _.isEmpty(cookies.get('calltrk_referrer'))
    ) {
      currentReferrer = decodeURIComponent(cookies.get('calltrk_referrer'));
    }

    const data = {
      action: 'compare_referrer',
      referrer: currentReferrer
    };

    if (cookies.get('_sk_referer')) return;

    jQuery.post(ajaxurl, data, (response) => {
      const refData = jQuery.parseJSON(response);

      // If there was no referrer found or available do nothing
      if (refData.referrer === 'no ref') {
        return;
      }
      cookies.set('_sk_referer', currentReferrer);
      if (_.isEmpty(refData.utm_source)) return;
      cookies.set('utm_source', refData.utm_source);
      cookies.set('utm_medium', refData.utm_medium);
    });
  }
};

export default getReferer;
